/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxcMutualfundsV1FundOrderState } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXC_MUTUALFUNDS_V1_FUND_ORDER_STATE_ENTITY_NAME = 'ixc.mutualfunds.v1.FundOrder';
export const ixcMutualfundsV1FundOrderStateEntity = new schema.Entity<IxcMutualfundsV1FundOrderState>(IXC_MUTUALFUNDS_V1_FUND_ORDER_STATE_ENTITY_NAME, {}, { idAttribute: 'fundOrderId' });

